import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axioKit } from "../../../../utilities";

const url = "/diagnostics/clinic/settlements";

const getTodayDate = () => {
  const today = new Date();
  const timezoneOffset = today.getTimezoneOffset() * 60000;

  return new Date(today.getTime() - timezoneOffset).toISOString().slice(0, 10);
};

const initialState = {
  collections: [],
  reportDate: getTodayDate(),
  activeTab: "list",
  searchKey: "",
  clinicFilter: "all",
  lastFetchedDate: "",
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const BROWSE = createAsyncThunk(
  `${url}/dailyCollections`,
  ({ token, data }, thunkAPI) => {
    try {
      return axioKit.universal(`${url}/browse`, token, data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      return thunkAPI.rejectWithValue(message);
    }
  },
);

export const reduxSlice = createSlice({
  name: "dailyCollections",
  initialState,
  reducers: {
    SetReportDate: (state, { payload }) => {
      state.reportDate = payload || getTodayDate();
    },
    SetActiveTab: (state, { payload }) => {
      state.activeTab = payload === "analytics" ? "analytics" : "list";
    },
    SetSearchKey: (state, { payload }) => {
      state.searchKey = payload || "";
    },
    SetClinicFilter: (state, { payload }) => {
      state.clinicFilter = payload || "all";
    },
    RESET: (state) => {
      state.isSuccess = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(BROWSE.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(BROWSE.fulfilled, (state, action) => {
        state.collections = Array.isArray(action.payload?.payload)
          ? action.payload.payload
          : [];
        state.lastFetchedDate = state.reportDate;
        state.isSuccess = Boolean(action.payload?.success);
        state.message = action.payload?.message || "";
        state.isLoading = false;
      })
      .addCase(BROWSE.rejected, (state, action) => {
        state.message = action.payload || action.error?.message || "";
        state.isLoading = false;
      });
  },
});

export const { SetReportDate, SetActiveTab, SetSearchKey, SetClinicFilter, RESET } =
  reduxSlice.actions;

export default reduxSlice.reducer;
